import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useState } from "react";
import { auth } from "./firebase";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';



export default function MobileNavBar() {
    const [usr, setUsr] = useState('Log In');
    const [logged, setLogged] = useState('/login');
    const [value, setValue] = React.useState(0);


    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(function (user) {
            if (user) {
                setUsr(`Welcome, ${user.displayName}!`);
                setLogged('/profile');
            } else {
                setUsr('Log in');
                setLogged('/login');
            }
        });

        // Cleanup the subscription when the component unmounts
        return () => unsubscribe();
    }, []);

    return (
        <Box sx={{ width: "100%" }}>
        <div style={{ marginBottom: '55px' }}></div>
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    >
                    <BottomNavigationAction component={RouterLink} to="/" label="Home" icon={<HomeOutlinedIcon />} />
                    <BottomNavigationAction component={RouterLink} to="/resources" label="Resources" icon={<DescriptionIcon />} />
                    <BottomNavigationAction component={RouterLink} to="/about" label="About Us" icon={<InfoIcon />} />
                    <BottomNavigationAction component={RouterLink} to="/help" label="Help" icon={<HelpIcon />} />
                    <BottomNavigationAction component={RouterLink} to={logged} label={usr} icon={<AccountCircleIcon />} />
                </BottomNavigation>
            </Paper>
        </Box>
    );
}